import { Component } from '@angular/core';


export class SkyTileTitleComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-tile-title',
  template: `<ng-content></ng-content>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
